<template>
  <Layout>
    <div class="row"  v-if="userData.permissions['view_company_profile']==1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-for="item in profiles" :key="item.id">
            <form @submit.prevent="UpdateProfile">
              <div class="row">
                  <div class="col-lg-4">
                    <div class="form-group mb-2">
                      <b-form-group label="Facility Name">
                      <input :value="item.name" type="text" readonly style="background: none;" class="form-control text-primary" />
                      </b-form-group>
                    </div>  
                    <div class="form-group mb-2">
                      <b-form-group label="Address">
                      <input :value="item.location" type="text" readonly style="background: none;" class="form-control text-primary" />
                      </b-form-group>
                    </div> 
                    <div class="form-group mb-2">
                      <b-form-group label="Telephone">
                      <input :value="item.telephone" type="text" readonly style="background: none;" class="form-control text-primary" />
                      </b-form-group>
                    </div> 
                    <div class="form-group mb-2">
                      <b-form-group label="Email Address">
                      <input :value="item.email" type="text" readonly style="background: none;" class="form-control text-primary" />
                      </b-form-group>
                    </div> 
                  </div>

                  <div class="col-lg-4">
                    <div class="form-group mb-2">
                      <b-form-group label="SMS Balance">
                      <input :value="item.sms_balance" type="text" readonly style="background: none;" class="form-control text-primary" />
                      </b-form-group>
                    </div> 
                    <div class="form-group mb-2">
                      <b-form-group label="Facility Logo">
                        <input type="file" class="form-control" v-on:change="onLogoChange">
                      </b-form-group>
                    </div>
                    <span v-if="item.logo!=0">
                      <img :src="getFiles(item.logo)" height="100px" />
                    </span>
                    <span v-else>
                        <img src="@/assets/images/default.jpg" height="100px"/>
                    </span>
                    <div class="form-group"><br>
                    <b-button type="submit" class="btn w-100" variant="primary"><i class="fas fa-check-circle"></i> Update</b-button>
                    </div>
                  </div>
                  <div class="col-lg-4 my-auto">
                     <img src="@/assets/images/bana.png" height="170px"/>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View the Company Profile</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { profileMethods, profileComputed } from "@/state/helpers";

export default {
  page: {
    title: "Facility Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      logo: "",
    };
  },
  methods: {
    ...profileMethods,
    onLogoChange(e){ this.logo = e.target.files[0]; },
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    async UpdateProfile() { 
        const config = { headers: { 'content-type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append("logo", this.logo);
        let url = "/updateprofile";
        await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
            this.fetchProfile();
            this.logo="";
            this.$toast.success(response.data.message);
        }
        });
      },
  },
  computed: {
    ...profileComputed,
  },
  mounted() {
    this.fetchProfile();
  },
};
</script>